import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  TextField,
  Checkbox,
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
  CircularProgress,
  Typography,
  Box,
} from "@mui/material";
import axios from 'src/utils/axios';

const ModelSelectorDialog = ({ open, onClose, field, setModelSelectorDialogValueString, handleCriteriaChangeValueForMultiSelect }) => {
  const [searchText, setSearchText] = useState("");
  const [models, setModels] = useState([]);
  const [selectedModels, setSelectedModels] = useState([]);
  const [loading, setLoading] = useState(false);
  

  useEffect(() => {
    if (searchText.trim() !== "") {
      fetchModels(searchText);
    } else {
      setModels([]);
    }
  }, [searchText]);

  const fetchModels = async (searchParam) => {
    setLoading(true);
    try {
      const response = await axios.get(
        `/GetModelsFromSearchParam/${encodeURIComponent(searchParam)}`
      );
      setModels(response.data || []);
    } catch (error) {
      console.error("API Error:", error);
      setModels([]);
    } finally {
      setLoading(false);
    }
  };

  const handleToggle = (model) => {
    setSelectedModels((prevSelected) => {
      const isSelected = prevSelected.some((item) => item.Id === model.Id);
      const tmpData = isSelected
        ? prevSelected.filter((item) => item.Id !== model.Id)
        : [...prevSelected, model];
      setModelSelectorDialogValueString(tmpData.map((item) => item.Value).join(", "));
      //sadece Idleri array olarak gönderiyoruz
      handleCriteriaChangeValueForMultiSelect(tmpData.map((item) => item.Id), field);
      return tmpData;
    });
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth>
      <DialogTitle>Model Seç</DialogTitle>
      <DialogContent
        style={{
          paddingTop: 5,
        }}
      >
        <TextField
          fullWidth
          label="Model Ara"
          variant="outlined"
          value={searchText}
          onChange={(e) => setSearchText(e.target.value)}
          autoFocus
        />
        {loading ? (
          <CircularProgress style={{ display: 'block', margin: '20px auto' }} />
        ) : (
          <Box mt={2} p={1} border={1} borderColor="grey.300" borderRadius={1}>
            <Typography variant="subtitle1" sx={{ fontWeight: 'bold', mb: 1 }}>
              Model Listesi
            </Typography>
            <List>
              {selectedModels.map((model) => (
                <ListItem key={model.Id} button onClick={() => handleToggle(model)}>
                  <ListItemIcon>
                    <Checkbox checked={true} />
                  </ListItemIcon>
                  <ListItemText primary={model.Value} />
                </ListItem>
              ))}
              {models
                .filter((model) => !selectedModels.some((item) => item.Id === model.Id))
                .map((model) => (
                  <ListItem key={model.Id} button onClick={() => handleToggle(model)}>
                    <ListItemIcon>
                      <Checkbox checked={false} />
                    </ListItemIcon>
                    <ListItemText primary={model.Value} />
                  </ListItem>
                ))}
            </List>
          </Box>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default ModelSelectorDialog;
